exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".HomeSlider-navigationIcon-3lyy7 {\n    display: block;\n    fill: rgb(118, 118, 118);\n    height: 36px;\n    width: 36px;\n    font-size: 36px;\n}\n.HomeSlider-noMargin-1KCTn {\n    margin: 0 auto;\n}\n.HomeSlider-padding-22vQl {\n    padding: 0 10px;\n}\n", "", {"version":3,"sources":["/root/bettertrip-web-app/src/components/Home/HomeSlider/HomeSlider.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,gBAAgB;CACnB;AACD;IACI,eAAe;CAClB;AACD;IACI,gBAAgB;CACnB","file":"HomeSlider.css","sourcesContent":[".navigationIcon {\n    display: block;\n    fill: rgb(118, 118, 118);\n    height: 36px;\n    width: 36px;\n    font-size: 36px;\n}\n.noMargin {\n    margin: 0 auto;\n}\n.padding {\n    padding: 0 10px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"navigationIcon": "HomeSlider-navigationIcon-3lyy7",
	"noMargin": "HomeSlider-noMargin-1KCTn",
	"padding": "HomeSlider-padding-22vQl"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Home/HomeSlider/HomeSlider.css
// module id = 2613
// module chunks = 8